//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';

import {colors} from '../../../assets/styles/colors';
import CustomButton from '../../../elements/CustomButton/CustomButton';

import type {ApplicableCoupon} from '../../../entities';

type Props = {
  promotionApplied: boolean,
  applicableCoupons?: ApplicableCoupon[],
  onApplyCoupon: (couponCode: string) => void,
  onRemoveCoupon: () => void,
  currentCoupon?: string,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    border: `0.5px solid ${colors.grey400}`,
    borderRadius: '6px',
    background: colors.grey200,
  },
  couponItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '8px',
    padding: '8px',
    background: 'white',
    borderRadius: '6px',
  },
  couponCode: {
    fontSize: '12px',
    fontWeight: 600,
    color: colors.grey800,
  },
  couponBtn: {
    fontSize: '12px',
    color: colors.purple,
    padding: 0,
  },
}));

export default function CouponForm(props: Props) {
  const {
    promotionApplied,
    applicableCoupons,
    onApplyCoupon,
    currentCoupon,
    onRemoveCoupon,
  } = props;

  const classes = useStyles();

  if (!applicableCoupons)
    return (
      <div className={classes.root}>
        <div className={classes.couponItem}>
          <Typography className={classes.couponCode}>
            No hay cupones disponibles
          </Typography>
        </div>
      </div>
    );

  return (
    <div className={classes.root}>
      {promotionApplied ? (
        <div className={classes.couponItem}>
          <Typography className={classes.couponCode}>
            No hay cupones disponibles para ordenes con promoción aplicada.
          </Typography>
        </div>
      ) : applicableCoupons.length > 0 ? (
        applicableCoupons.map(coupon => {
          const thisCouponIsApplied = currentCoupon === coupon.code;

          const handleClick = () => {
            if (thisCouponIsApplied) return onRemoveCoupon();
            onApplyCoupon(coupon.code);
          };
          return (
            <div key={coupon.code} className={classes.couponItem}>
              <Typography className={classes.couponCode}>
                {coupon.code}
              </Typography>
              <CustomButton className={classes.couponBtn} onClick={handleClick}>
                {thisCouponIsApplied ? 'remover' : 'aplicar'}
              </CustomButton>
            </div>
          );
        })
      ) : (
        <div className={classes.couponItem}>
          <Typography className={classes.couponCode}>
            No hay cupones disponibles
          </Typography>
        </div>
      )}
    </div>
  );
}
